import { render, staticRenderFns } from "./OsTypeConfigTable.vue?vue&type=template&id=38722816"
import script from "./OsTypeConfigTable.vue?vue&type=script&lang=js"
export * from "./OsTypeConfigTable.vue?vue&type=script&lang=js"
import style0 from "./OsTypeConfigTable.vue?vue&type=style&index=0&id=38722816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports